import { useCallback, useEffect, useMemo, useState } from 'react';
import { DefaultRootState, useDispatch, useSelector } from 'react-redux';

import { TradeDto } from 'common/api/autogenerated/trading-gateway';

import { useCustomer } from 'common/hooks';

import { actionDeleteOrder, actionGetCustomerTrades } from 'components/Orders/list/redux/orders.actions';

export const useTrades = (filterFn: (order: TradeDto) => boolean = () => true, waitFn = false, useCached = false) => {
  const dispatch = useDispatch();
  const [initiallyWasLoaded, setInitiallyWasLoaded] = useState(false);

  const { isAuthenticated } = useCustomer();

  const loading = useSelector((state: DefaultRootState) => state.ordersReducer.loading);
  const trades = (useSelector((state: DefaultRootState) => state.ordersReducer.trades) || []).filter(filterFn);
  const cancel = useCallback((id: number, symbol: string) => dispatch(actionDeleteOrder(id, symbol)), [dispatch]);
  const reload = useCallback(() => dispatch(actionGetCustomerTrades()), [dispatch]);

  const userNotAuthenticated = useMemo(() => !isAuthenticated, [isAuthenticated]);
  const isWaitingToProvideFilterFn = useMemo(() => waitFn && !filterFn, [filterFn, waitFn]);
  const existsCached = useMemo(() => useCached && !!trades?.length, [trades?.length, useCached]);

  useEffect(() => {
    if (userNotAuthenticated || isWaitingToProvideFilterFn || initiallyWasLoaded || existsCached) return;
    dispatch(actionGetCustomerTrades());
    setInitiallyWasLoaded(true);
  }, [dispatch, existsCached, isWaitingToProvideFilterFn, initiallyWasLoaded, userNotAuthenticated]);

  return { trades, cancel, loading, reload };
};
